/**
 * Checklist 用户自定义 Location 标签。
 * 只读接口顶层字段（与 values.location / Set Value 无关）。
 *
 * 后端约定（list / detail / create）：
 * - locations: ["22"]           存库值（可不带 #）
 * - locations_text: ["#22"]     展示用
 * - locations_display: "#22"    拼接展示
 * - location: ["22"]            兼容别名
 */

/** 规范化标签列表（补 #、去空） */
export function normalizeLocationTags(tags?: string[] | null): string[] {
  if (!tags?.length) return []
  return tags
    .map((tag) => {
      const text = String(tag).trim()
      if (!text) return ''
      return text.startsWith('#') ? text : `#${text}`
    })
    .filter(Boolean)
}

/** 用户输入 → #Xxxx */
export function normalizeLocationTag(raw: string): string {
  const text = raw.trim().replace(/^#+/, '')
  if (!text) return ''
  const labeled = text.charAt(0).toUpperCase() + text.slice(1)
  return `#${labeled}`
}

/**
 * 从 checklist 条目根对象取 Location 标签。
 * 优先 locations_text → locations → location（顶层）；绝不读 values.location。
 */
export function pickLocationsFromApiItem(item: unknown): string[] {
  if (!item || typeof item !== 'object') return []
  const row = item as Record<string, unknown>

  if (Array.isArray(row.locations_text)) {
    return normalizeLocationTags(row.locations_text as string[])
  }
  if (typeof row.locations_display === 'string' && row.locations_display.trim()) {
    return normalizeLocationTags(
      row.locations_display.split(/[,，]/).map((s) => s.trim()).filter(Boolean),
    )
  }
  if (Array.isArray(row.locations)) {
    return normalizeLocationTags(row.locations as string[])
  }
  // 顶层 location（非 values.location）
  if (Array.isArray(row.location) && row.location.every((x) => typeof x === 'string')) {
    return normalizeLocationTags(row.location as string[])
  }
  return []
}

/** 列表 / 详情 / 编辑回显：只信接口 */
export function resolveLocationsForItem(item: unknown): string[] {
  return pickLocationsFromApiItem(item)
}
